import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { UserContext } from "../../context/UserContext";
import Spinner from "../sample/spinner";
import { toast } from "react-toastify";
import {
  Card,
  Row,
  Col,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CardHeader,
} from "reactstrap";
import NotificationsOffIcon from "@material-ui/icons/NotificationsOff";
import DeleteIcon from "@material-ui/icons/Delete";
import Button from "@material-ui/core/Button";
import { Redirect } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

const Notification = () => {
  const [loading, setLoading] = useState(true);
  const context = useContext(UserContext);
  const [notification, setNotification] = useState([]);
  const [notificationmodal, setNotificationModal] = useState([]);
  const [Feedmodal, setFeedmodal] = useState(false);
  const classes = useStyles();
  useEffect(() => {
    getAllNotifications();
  }, []);
  const getAllNotifications = () => {
    axios
      .post("Learner/getAllNotification")
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          setLoading(false);
          //   context.setUser({ email: localStorage.getItem("user"), token: localStorage.getItem("token") ,notification:res.data.notificationsize})
          setNotification(res.data.notification);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  const getpopup = (item) => {
    let formData = new FormData();
    formData.append("notification", item);
    axios
      .post("Learner/getPopUpNotification", formData)
      .then((res) => {
        // console.log(res.data);
        if (res.data.status === "200" || res.data.status === "100") {
          setNotificationModal(res.data);

          setFeedmodal(true);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        toast.error("Please try again!!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  const clearAllNotification = () => {
    axios
      .post("Learner/clearAllNotification")
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          // context.setUser({ email: localStorage.getItem("user"), token: localStorage.getItem("token") ,notification:"0"})
          setNotification([]);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  const handleRemove = (id) => {
    // console.log(id);
    let formData = new FormData();
    formData.append("notification", id);
    axios
      .post("Learner/clearOneNotification", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          // context.setUser({ email: localStorage.getItem("user"), token: localStorage.getItem("token") ,notification:res.data.notificationsize})
          const newList = notification.filter((item) => item.id !== id);
          setNotification(newList);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  if (!context?.user?.email) {
    return <Redirect to="/" />;
  }
  return (
    <div>
      <section className="padding-default3">
        {loading ? (
          <Spinner />
        ) : (
          <>
            <Row>
              <Col sm={12}>
                {notification.length > 0 ? (
                  <>
                    <Row>
                      <Col sm={8}>
                        {/* <h4>Notifications</h4>  */}
                      </Col>
                      <Col sm={4}>
                       
                          {" "}
                          <Button color="secondary">
                          <span
                          onClick={(e) => clearAllNotification()}
                          style={{ cursor: "pointer" }}
                        >
                            Clear All </span>
                          </Button>
                        
                      </Col>
                    </Row>
                    <hr style={{ margin: "6px" }} />
                    {notification.map((item, index) => (
                      <>
                        <Row>
                          <Col sm={12}>
                            <div className="coursecat1">
                              <Card
                                style={{
                                  width: "100%",
                                  // border: "1px solid #222",

                                  padding: "0.1px",
                                  height: "auto",
                                }}
                              >
                                <CardBody
                                  className="tab-border-color"
                                  style={{ cursor: "pointer" }}
                                >
                                  <Row>
                                    <Col sm={11}>
                                      <Link onClick={(e) => getpopup(item.id)}>
                                        <span style={{ cursor: "pointer" }}>
                                          {item.subject}
                                        </span>
                                      </Link>
                                    </Col>

                                    <Col sm={1}>
                                    
                                        <div className="padding-deelete2 float-right" >
                                          <Tooltip
                                            title="Delete Notification "
                                            aria-label="Delete Notification"
                                          >
                                            <DeleteIcon
                                              style={{
                                                color: "red",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                handleRemove(item.id)
                                              }
                                            />
                                          </Tooltip>
                                        </div>
                                      
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm={4}>
                                     {" "}
                                     <p style={{color:"grey"}}> <FontAwesomeIcon
                                        icon={faCalendarAlt}
                                        color="gray"
                                      /> &nbsp;{item.date}</p>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </div>
                          </Col>
                        </Row>
                      </>
                    ))}
                  </>
                ) : (
                  <center>
                    <NotificationsOffIcon
                      style={{ fontSize: 100 }}
                      color="disabled"
                    />
                     <Alert severity="warning"><b>No New Notification ! </b></Alert>
                  </center>
                )}
              </Col>
            </Row>
            <br />
          </>
        )}
      </section>
      <Modal
        isOpen={Feedmodal}
        toggle={() => setFeedmodal(!Feedmodal)}
        size="lg"
        // contentClassName="custom-modal-style"
      >
         {/* <ModalHeader toggle={() => setFeedmodal(!Feedmodal)}>
        </ModalHeader> */}
        {/*<ModalBody> */}
        <div>
          <span
          className="html-content"
            dangerouslySetInnerHTML={{
              __html: notificationmodal?.body,
            }}
          />
        </div>
        {/* </ModalBody>*/}
        <ModalFooter>
          <Button className="rounded-pill" variant="contained" color="secondary"  onClick={() => setFeedmodal(!Feedmodal)}>
            Close
          </Button>
        </ModalFooter> 
      </Modal>
    </div>
  );
};

export default Notification;
